import {
  WSElement,
  WSIconList,
  WSInfoBox,
  WSList,
  WSTable,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { WS_LINKS } from "../../../../../types/wsLinks";

export const AboutOAI: React.FC<{}> = ({}) => {
  type CoverageRow = { label: string; value: string };

  const rows: CoverageRow[] = [
    {
      label: "Accident Medical Expense",
      value:
        "Up to $1,000,000 for necessary medical treatment resulting from a covered accident."
    },
    {
      label: "Temporary Total Disability",
      value:
        "70% of average weekly earnings (up to $500/week) if you are unable to work due to a covered injury."
    },
    {
      label: "Continuous Total Disability",
      value:
        "Up to $200,000 total (Benefits available if an injury results in a long-term disability)"
    },
    {
      label: "Accidental Death & Survivor Benefits:",
      value: "Financial support for your beneficiaries."
    }
  ];

  return (
    <WSElement>
      <WSText.Paragraph weight="medium" mb="XL">
        About
      </WSText.Paragraph>
      <WSList gap="S" mb="L">
        <WSInfoBox title="What is it?" icon="bulb">
          Protect yourself from the costs of work-related accidents. OAI
          provides benefits for medical expenses and lost income if you are
          injured while performing services paid through the Wingspan platform.
          As an independent contractor, your personal health insurance may deny
          work-related claims.
        </WSInfoBox>
        <WSInfoBox title="This insurance is designed for:" icon="bulb">
          <WSIconList
            mt="M"
            inlineIcons
            textProps={{
              kind: "ParagraphSm"
            }}
            iconProps={{
              name: "check-circle",
              color: "green500"
            }}
            items={[
              <>
                <b>Driving & Delivery:</b> Operating a motor vehicle to
                transport goods, materials, or people.
              </>,
              <>
                <b>Auto Detailing:</b> Performing cleaning, washing, or
                restoration services on the interior or exterior of vehicles.
              </>,
              <>
                <b>Claims Inspector:</b> Inspecting and assessing damage to
                property or vehicles to report on a claim.
              </>,
              <>
                <b>Professional & Administrative Services:</b> Providing
                technical, creative, administrative, or other professional
                support services (e.g., development, design, data management,
                contact center work).
              </>
            ]}
          />
        </WSInfoBox>

        <WSInfoBox
          title="What does is cover?"
          icon="shield-check-fill"
          theme="neutral"
        >
          <WSInfoBox
            title="IMPORTANT NOTICE:"
            icon="alert"
            colorBackground="amber50"
          >
            This insurance is <b>NOT</b> Workers’ Compensation insurance and is
            not a substitute for Workers’ Compensation.{" "}
            <b>This policy covers losses due to accidents only;</b> it does not
            cover sickness.
          </WSInfoBox>

          <WSElement my="L">
            <WSText.ParagraphSm weight="medium" mb="NONE">
              Policy highlights
            </WSText.ParagraphSm>
          </WSElement>

          <WSTable<CoverageRow>
            tableData={rows.map(r => ({ id: r.label, data: r }))}
            columns={[
              {
                config: {
                  gridTemplateSizeMax: "999px"
                },
                renderFunction: ({ data }) => (
                  <WSText.ParagraphSm weight="medium">
                    {data.label}
                  </WSText.ParagraphSm>
                )
              },
              {
                config: {
                  gridTemplateSizeMax: "999px"
                },
                renderFunction: ({ data }) => (
                  <WSText.ParagraphXs weight="light">
                    {data.value}
                  </WSText.ParagraphXs>
                )
              }
            ]}
          />
        </WSInfoBox>

        <WSInfoBox icon="link">
          <a target="_blank" rel="noreferrer" href={WS_LINKS.wingspanAOIPolicy}>
            View full policy details
          </a>
          <br />
          <b>Insurer: </b>Underwritten by Atlantic Specialty Insurance Company
          (Intact Insurance).
        </WSInfoBox>
      </WSList>
    </WSElement>
  );
};
